module.exports = __webpack_public_path__ + "static/media/employee-appreciation-1.2b4d256c.jpeg";